import { createActions } from 'redux-actions';
import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../lib/reduxActionsUtils';
import { Dispatch } from 'redux';
import paymentsApi from '../../api/paymentsApi';

export const { setCheckoutId, getCheckoutPending, getCheckoutFullfilled, getCheckoutRejected } = createActions(
  actionTypes.SET_CHECKOUT_ID,
  actionTypes.GET_CHECKOUT_FULLFILLED,
  actionTypes.GET_CHECKOUT_PENDING,
  actionTypes.GET_CHECKOUT_REJECTED,
  getActionOptions(ACTION_PREFIX)
);

const setCheckOut = (id: string) => (dispatch: Dispatch<any>) => {
  return dispatch(setCheckoutId(id));
};

const getCheckOutSummary = (id: string) => async (dispatch: Dispatch<any>) => {
  dispatch(getCheckoutPending());
  try {
    const response = await paymentsApi.getCheckOutSummary(id);
    return dispatch(getCheckoutFullfilled(response));
  } catch (error) {
    return dispatch(getCheckoutRejected(error));
  }
};

export default {
  getCheckOutSummary,
  setCheckOut,
};
